const truncate = (str, length) => {
    if (str) {
        if (str.length <= length) {
            return str;
        }

        return `${str.substr(0, length)}...`;
    }

    return ""
}

const prettify = str => str
    .replace(/([A-Z]+)([A-Z][a-z])/g, ' $1 $2')
    .replace(/([a-z\d])([A-Z])/g, '$1 $2')
    .replace(/([a-zA-Z])(\d)/g, '$1 $2')
    .replace(/^./, function (str) { return str.toUpperCase(); })
    .trim();

export {
    truncate,
    prettify
}